<template>
  <div class="viewChart">
    <div class="chartsDP" id="view_chartID" v-show="!state.viewDP.noData&&!chart.comp.show"></div>
    <div class="comNoData" v-show="state.viewDP.noData"><span>暂无数据</span></div>
    <component :is="chart.comp.component" class="view_comp" type="view" v-show="!state.viewDP.noData&&chart.comp.show"></component>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/6/21 9:28 上午
 */
export default {
  name: 'viewChart',
  components: {},
  props: {},
  data() {
    return {
    }
  },
  computed: {
    state() {
      return this.$store.state;
    },
    chart() {
      return this.$store.state.viewDP.chart;
    },
    nowChart() {
      return this.$store.state.viewDP.nowChart || {};
    }
  },
  methods: {
  },
  mounted() {
  },
  destroyed() {

  }
}
</script>

<style lang="less">
.viewChart {
  width: 100%;
  height: 100%;

  .view_comp {
    width: 100%;
    height: 100%;
  }
}
.el-scrollbar__wrap{
  margin-right: 0px !important;
  margin-bottom: 0px !important;
}
</style>